/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import { render } from 'react-dom';

//I18n Configuration
import lang from 'i2l?query=sporks!../lang/en.lyaml';
import BasicPublicI18nSetup from 'I18n/init/setup/BasicPublicI18nSetup';
import http from 'hub-http/clients/noPortalApiClient';

// Redux
import { Provider } from 'react-redux';
import configureStore from './utils/configureStore';

// Configure the router
import { Router } from 'react-router-dom';
import routes from './Routes';
import { getRootUrl } from './utils/urls';
import { createBrowserHistory } from 'history';

// React-rhumb
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import historyAdapter from 'react-rhumb/historyAdapterV4';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Redu... Remove this comment to see the full error message
import NotificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
export default class Application {
  // Kicks off the app. This is intentionally not in the constructor just in
  // case there is a reason you need to explicitly call init (and don't want it
  // auto-called by importing this module)
  start() {
    if ('jasmine' in window) return;
    window.AppInstance = this;
    this.init().then(user => {
      const manualLocaleSettings = {
        locale: user.user.locale,
        langEnabled: user.user.languageEnabled
      };
      BasicPublicI18nSetup.setup({
        lang,
        manualLocaleSettings
      }).then(() => {
        this.startReduxAndRaven(user);
      }).catch(err => console.error(err));
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }

  // Performs all the initialization needed before the main app code can run/render.
  init() {
    return http.get('/login-verify/user-info');
  }
  startReduxAndRaven(user) {
    const middleware = [NotificationMiddleware];
    this.store = configureStore({
      auth: {
        user
      }
    }, middleware);
    Raven.setUserContext({
      id: user.id,
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ id: any; locale: any; }' is no... Remove this comment to see the full error message
      locale: user.locale
    });
    this.startRouter();
  }
  startRouter() {
    const history = createBrowserHistory({
      basename: getRootUrl()
    });
    render( /*#__PURE__*/_jsx(Provider, {
      store: this.store,
      children: /*#__PURE__*/_jsx(RhumbProvider, {
        config: rhumbConfig,
        history: historyAdapter(history),
        children: /*#__PURE__*/_jsx(Router, {
          history: history,
          children: routes
        })
      })
    }), document.getElementsByClassName('page')[0]);
  }
}